<template>
    <div>
        <!-- 用户 -->
        <div class="users">
            <div @click="selectUsers()">
                <Button type="primary" @click="modal = true" v-hasPermission="['permissionsConfigurationManagement:resourcePermission:add_user']">{{$t('permission_configuration_management.group.addUser')}}</Button>
            </div>
        </div>
        <Modal v-model="modal" :title="$t('permission_configuration_management.group.addUser')" width="900px;" :loading="modalLoading"
               :okText="$t('permission_configuration_management.common.confirm')" :cancelText="$t('permission_configuration_management.common.cancel')"
               :mask-closable="false" :closable="false">
            <div slot="footer">
                <Button @click="cancel()">{{$t('permission_configuration_management.common.cancel')}}</Button>
                <Button type="primary" @click="handleSubmit()" :loading="addloading" :disabled="isDisable">{{$t('permission_configuration_management.common.confirm')}}</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" ref="selection" :columns="columns" :loading="loading" :data="queryAccountUsersData" :height="400" @on-selection-change="getSelection"></Table>
        </Modal>
        <table-users></table-users>
    </div>
</template>

<script>
    import {getCookie} from '../../../../utils/cookieUtil.js'
    import TableUsers from '../resource_permission/TableUsers'

    var tableUsers = TableUsers;
    export default {
        name: 'AddUsers',
        components: {
            TableUsers
        },
        data() {
            return {
                selection: [],
                modal: false,
                modalLoading: true,
                loading: false,
                addloading:false,
                isDisable: true,
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: this.$t('permission_configuration_management.user.userName'),
                        key: 'name'
                    },
                    {
                        title:this.$t('permission_configuration_management.account.company'),
                        key:'companyName'
                    },
                    {
                        title: this.$t('permission_configuration_management.user.email'),
                        key: 'email'
                    },
                    {
                        title: this.$t('permission_configuration_management.user.loginStatus'),
                        key: 'isState'
                    },
                    {
                        title: this.$t('permission_configuration_management.user.accountStatus'),
                        key: 'isActive'
                    }
                ],
                queryAccountUsersData: [],
                newQueryAccountUsersList:[]
            }
        },
        methods: {
            selectUsers: function () {
                this.$api.user.queryGroupByUser("groupId", this.$route.query.id)
                    .then(res => {
                        this.queryAccountUsersData = res.data;
                        // 显示状态
                        for (var i = 0; i < this.queryAccountUsersData.length; i++) {
                            // 登陆状态
                            if (this.queryAccountUsersData[i].state == 1) {
                                this.queryAccountUsersData[i].isState = this.$t('permission_configuration_management.user.onLine')
                            } else if (this.queryAccountUsersData[i].state == 0) {
                                this.queryAccountUsersData[i].isState = this.$t('permission_configuration_management.user.offLine')
                            }
                            // 是否有效
                            if (this.queryAccountUsersData[i].active) {
                                this.queryAccountUsersData[i].isActive = this.$t('permission_configuration_management.user.enable')
                            } else {
                                this.queryAccountUsersData[i].isActive = this.$t('permission_configuration_management.user.disable')
                            }
                        }
                        tableUsers.methods.showAllUser();
                    })
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newQueryAccountUsersList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    this.newQueryAccountUsersList.push(this.selection[i].id);
                }

                // 选了数据 可以点击下一步
                if (this.newQueryAccountUsersList.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            // 添加
            handleSubmit: function () {
                this.addloading=true;
                this.$api.groupUserRelation.createGroupUserRelation({
                    "groupId": this.$route.query.id,
                    "userList":this.newQueryAccountUsersList
                }).then(res => {
                    setTimeout(() => {
                        tableUsers.methods.showAllUser();
                        this.modalLoading = false;
                        this.$nextTick(() => {
                            this.modalLoading = true;
                        });
                        this.$Message.success(this.$t('common.addSuccess'));
                        this.queryAccountUsersData=[];
                        this.newQueryAccountUsersList=[];
                        this.modal = false;
                        this.isDisable = true;
                        this.addloading=false;
                    }, 1000);
                })
            },
             // 取消
            cancel: function () {
                this.isDisable = true;
                this.modal = false;
                this.queryAccountUsersData=[];
                this.newQueryAccountUsersList=[];
            }
        }
    }
</script>

<style scoped>
  /*users*/
  .users {
    width: 100%;
    margin-bottom: 10px;
    overflow: hidden;
  }

  .users>div:nth-child(1) {
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/AddUsers.vue